import _ from 'lodash'
import { languagesFonts } from './v13.languages'
import { studioFonts } from './fonts.helveticas'
import { madeforFonts } from './fonts.madefor.v11'
import { googleFonts } from './fonts.googleapis'

const cssRules = {
	...googleFonts,
	...languagesFonts,
	...studioFonts,
	...madeforFonts,
}

const CONSTANTS = {
	UPLOADED_FONT_PREFIX: 'wf_',
	LONG_UPLOADED_FONT_PREFIX: 'wfont_',
}

const UPLOADED_FONT_MASK = 'wfont_[0-9a-f]{6}_[0-9a-f]{32}'
const UPLOADED_FONT_TEST = new RegExp(`^${UPLOADED_FONT_MASK}`)

export function isUploadedFontFamily(fontFamilyStr: string) {
	if (_.isNil(fontFamilyStr) || _.isEmpty(fontFamilyStr)) {
		return false
	}

	const fontName = _.head(fontFamilyStr.split(','))!
	return UPLOADED_FONT_TEST.test(fontName)
}

function getShortUploadedFontFamily(font: string) {
	const newLocal = /^wfont_[0-9a-f]{6}_([0-9a-f]{25})[0-9a-f]{7}/.exec(font)!
	return `wf_${newLocal[1]}`
}

function getUploadedId(uploadedFonStr: string) {
	return uploadedFonStr.replace(CONSTANTS.LONG_UPLOADED_FONT_PREFIX, '').trim()
}

function getUploadFontFace(font: string, mediaRootUrl: string) {
	const shouldAddProtocol = !mediaRootUrl.startsWith('http')
	mediaRootUrl = shouldAddProtocol ? `https://${mediaRootUrl}/` : mediaRootUrl
	const fontName = _.head(font.split(',')) || ''
	const fontId = getUploadedId(fontName)
	const shortFontName = getShortUploadedFontFamily(fontName)
	return `@font-face {
font-family: ${shortFontName};
src: url("${mediaRootUrl}ufonts/${fontId}/woff2/file.woff2") format("woff2"),
url("${mediaRootUrl}ufonts/${fontId}/woff/file.woff") format("woff"),
url("${mediaRootUrl}ufonts/${fontId}/ttf/file.ttf") format("ttf");
}`
}

export const getFontFacesCss = (fontFamilies: Array<string>, mediaRootUrl: string): string => {
	const fonts = fontFamilies.reduce<Array<string>>((resultArray, fontFamily) => {
		const isUploadedFont = isUploadedFontFamily(fontFamily)
		const fontFaces = isUploadedFont ? getUploadFontFace(fontFamily, mediaRootUrl) : cssRules[fontFamily]
		return resultArray.concat(fontFaces)
	}, [])
	const fontsCss = _.compact(fonts).join('\n')
	return fontsCss
}
